
import { Component, Prop } from 'vue-property-decorator';
import { EVENTS } from '@/author/constants';
import { generateHash } from '@/author/components/helper/hash';
import ModalStackChildren from '@/mixins/ModalStackChildren';

@Component
export default class ModalAudioPlayer extends ModalStackChildren {
  @Prop(Boolean) completionByInnerComponent?: boolean;
  @Prop({ type: String, required: true }) src!: string;
  @Prop({ type: String }) vttSrc!: string;
  @Prop({ type: String }) cover!: string;
  @Prop({ type: String }) accessibilityTitle?: string;
  @Prop({ type: String }) hiddenModalTitle?: string;
  @Prop({ type: Boolean }) autoplay!: boolean;
  completed: boolean = false;
  public $refs!: {
    modal: any;
  };
  created() {
    this.$parent?.$on('setup-modal', (hash: number) => {
      if (this.hash === hash) this.completed = true;
    });
  }
  handleLoaded() {
    setTimeout(() => {
      this.$refs.modal.trapFocus(true);
    }, 500);
  }
  handleCompleted() {
    if (this.completionByInnerComponent) this.completed = true;
    this.$parent?.$emit(EVENTS.COMPLETED, this.hash);
    this.$emit('modalcompleted');
  }
  get hash(): number {
    return generateHash(
      this.src + this.cover + this.vttSrc + this.accessibilityTitle
    );
  }
  get hiddenTitle(){
    return this.hiddenModalTitle || this.accessibilityTitle || '';
  }
  public isCompleted(): boolean {
    return this.completed;
  }
}
